'use client'
 
import { notFound } from 'next/navigation'
import { useEffect } from 'react'
 
export default function Error({ error, reset }) {
  useEffect(() => {
    console.log(error)
  }, [error])
 
  return (
    notFound()
  )
}